import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { SecondaryButton } from "../../Button";
import { processSheet } from "../thunk.js";
import { useDispatch, useSelector } from "react-redux";
import { merchantsSortedByName } from "../../Merchants";
import { LOADING_EMUNS } from "../constant";
import * as a from "../action";

const UploadSpreadSheetButton = () => {
  const dispatch = useDispatch();
  const merchantList = useSelector(merchantsSortedByName);
  const loadingState = useSelector((state) => state.ssUploader.loading.state);
  const file = useRef(null);

  const Button = styled(SecondaryButton)`
    width: 250px;
  `;

  useEffect(() => {
    if (loadingState === LOADING_EMUNS.LOADED) {
      dispatch(a.setLoadingState(LOADING_EMUNS.DEFAULT));
    }
  }, [loadingState]);

  if (loadingState === LOADING_EMUNS.DEFAULT) {
    return (
      <>
        <input
          type="file"
          ref={file}
          onChange={(e) => dispatch(processSheet(e, merchantList))}
          style={{ height: "0.1px", width: "0.1px", opacity: 0 }}
        />
        <Button onClick={() => file.current.click()}>Upload SpreadSheet</Button>
      </>
    );
  }

  if (loadingState === LOADING_EMUNS.LOADING) {
    return (
      <>
        <Button>SpreadSheet Processing....</Button>
      </>
    );
  }

  return null;
};

export { UploadSpreadSheetButton };
